<template>
  <div class="main">
    <div class="banner">
      <img src="@/assets/img/long-banner.png" alt="">
    </div>
    <div class="form-box">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm">
        <el-form-item label="项目名称/企业名称" prop="projectName">
          <el-input v-model="ruleForm.projectName"></el-input>
        </el-form-item>
        <el-form-item label="创业营加入时间" prop="joinCampTime">
          <el-input v-model="ruleForm.joinCampTime" placeholder="如：2022年春季创业营"></el-input>
        </el-form-item>
        <el-form-item label="意向场地" prop="intentionField">
          <el-checkbox-group v-model="ruleForm.intentionField">
            <el-checkbox label="中关村创业大街6号楼" name="intentionField"></el-checkbox>
            <el-checkbox label="全球创新社区（静淑苑路2号）" name="intentionField"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="联系人" prop="contacts">
          <el-input v-model="ruleForm.contacts"></el-input>
        </el-form-item>
        <el-form-item label="职位" prop="contactsPosition">
          <el-input v-model="ruleForm.contactsPosition"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="contactsPhone">
          <el-input v-model="ruleForm.contactsPhone"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="submit-btn" @click="submitForm('ruleForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import axios from '@/services/axios'
import { Message } from "element-ui"

export default {
  name:"stationForm",
  data() {
    return {
      ruleForm: {
        projectName: '',
        joinCampTime: '',
        contacts: '',
        intentionField: [],
        contactsPosition: '',
        contactsPhone: ''
      },
      rules: {
        projectName: [
          { required: true, message: '请输入项目名称/企业名称', trigger: 'blur' }
        ],
        contacts: [
          { required: true, message: '请填写联系人', trigger: 'blur' }
        ],
        intentionField: [
          { required: true, message: '请至少选择一个意向场地', trigger: 'change' }
        ],
        contactsPhone: [
          { required: true, message: '请填写联系方式', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm(formName) {
      let {
        projectName,
        joinCampTime,
        contacts,
        intentionField,
        contactsPosition,
        contactsPhone
      } = this.ruleForm
      this.$refs[formName].validate((valid) => {
        if (valid) {
          axios({
            url: '/innohallService/qj/addStationApply',
            method: 'POST',
            data: {
              projectName: projectName,
              joinCampTime: joinCampTime,
              contacts: contacts,
              intentionField: intentionField.join(','),
              contactsPosition: contactsPosition,
              contactsPhone: this.encryption(contactsPhone)
            }
          }).then(res => {
            if (res.status == 'success') {
              Message.success("提交成功!")
              this.$router.push('/home/index')
            }
          }).catch((error)=>{
            console.log(error)
          });
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  .banner {
    width: 100%;
    img {
      display: block;
      width: 100%;
      height: auto;
    }
  }
  .form-box {
    width: 600px;
    margin: 0 auto;
    padding: 40px 0;
  }
  .submit-btn {
      width: 116px;
      height: 44px;
      background: #0079FF;
      border-radius: 4px;
      border: none;
      color: #fff;
      margin-top: 20px;
      margin-left: 50px;
  }
  .submit-btn:hover {
    background-color: #0069DC;
  }
}
</style>>

 